import { dialogMessageCenter } from './message-center';
import { dialogMessageTop } from './message-top';

interface DialogMessage {
  message: string;
  onClose?: () => void;
  duration?: number;
  showMask?: boolean;
  className?: string;
}

type DialogMessageConfig = {
  type: 'top' | 'center';
  showMask?: boolean;
  duration?: number;
};

export const dialogMessage = (props: string | DialogMessage) => {
  const dialogMessageConfig = (window['_dialog_message_config'] ||
    window['dialogMessageConfig']) as DialogMessageConfig;

  let newProps = typeof props === 'string' ? { message: props } : props;

  if (dialogMessageConfig) {
    newProps = {
      showMask: dialogMessageConfig.showMask,
      duration: dialogMessageConfig.duration,
      ...newProps,
    };
    if (dialogMessageConfig.type === 'center') {
      dialogMessageCenter(newProps);
    } else {
      dialogMessageTop(newProps);
    }
  } else {
    dialogMessageTop(newProps);
  }
};
